import React, { useEffect } from 'react';
import Assets from '../components/updated/Assets';
import { useNavigate } from 'react-router-dom';
import Dashboard from '../components/updated/Dashboard';
import { baseURL } from '../services/api';
import { useAuth } from '../components/Hooks/useAuth';
import LoginRequiredPopup from '../components/updated/shared/LoginRequiredPopup';

const DashboardPage = () => {
  const navigate = useNavigate();
  const {
    showLoginPopup,
    handleLoginPopupClose,
    checkAuthentication,
    showLoginRequiredPopup,
  } = useAuth();

  useEffect(() => {
    if (!checkAuthentication()) {
      showLoginRequiredPopup();
    }
  }, [checkAuthentication, showLoginRequiredPopup]);

  return (
    <div>
      <Dashboard />
      {showLoginPopup && <LoginRequiredPopup onClose={handleLoginPopupClose} />}
    </div>
  );
};

export default DashboardPage;
